import { FC } from 'react';

import { Flex, Link, StyleProps, Text } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { Route } from '../../config/router';
import { pathWithId } from '../../utils/api';
import { ReactionAvatar } from './reaction-avatar';
import { ReactionData } from './types';

interface ReactionCardProps extends StyleProps {
	reaction: ReactionData;
}

export const ReactionCard: FC<ReactionCardProps> = ({ reaction, ...rest }) => {
	const recognizeURL = useBuildRecognizeURL();

	return (
		<Flex alignItems="center" {...rest}>
			<ReactionAvatar reaction={reaction} mr={4} />

			<Flex alignItems="flex-start" direction="column" flex={1} justifyContent="center" minWidth={0}>
				<Link
					textDecoration="none"
					_hover={{ textDecoration: 'underline' }}
					color="gray.700"
					href={recognizeURL(pathWithId(Route.UserProfile, reaction.user.id))}
				>
					<Text fontSize="md" fontWeight="medium" lineHeight="base">
						{reaction.user.display_name}
					</Text>
				</Link>
				<Text color="gray.600" fontSize="sm" fontWeight="normal" lineHeight="base">
					{reaction.user.username}
				</Text>
			</Flex>
		</Flex>
	);
};
